export default "__VITE_ASSET__DykAmYw6__"